import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '@grandvisionhq/utils';
import '../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import { SingleFacetPicker } from '../components/FacetPickerContainers/SingleFacetPicker/SingleFacetPicker.js';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { PriceSectionContainer } from '../components/PriceSection/PriceSectionContainer.js';
import { VariantSelectorTree } from '../components/VariantSelectorTree/VariantSelectorTree.js';
import '@grandvisionhq/content';
import { AccessoriesCTA } from './components/AccessoriesCTA/AccessoriesCTA.js';
import { AccessoriesQuantitySelector } from './components/AccessoriesQuantitySelector/AccessoriesQuantitySelector.js';

const AccessoriesEcommContent = ({ className , ctaRef  })=>{
    const { activeVariant: { displayName , sku: activeSku , isExcludedFromCheckout  } ,  } = useProductData();
    const { isOmnivariancyEnabled  } = useFeatureToggles();
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('accessories-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        className: "accessories-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(PriceSectionContainer, null), /*#__PURE__*/ React.createElement(Hr, null), isOmnivariancyEnabled ? /*#__PURE__*/ React.createElement(VariantSelectorTree, null) : /*#__PURE__*/ React.createElement(SingleFacetPicker, null), /*#__PURE__*/ React.createElement(AccessoriesQuantitySelector, null), /*#__PURE__*/ React.createElement("div", {
        className: "accessories-ecomm-content__column"
    }, Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ]
    }) : null, /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(AccessoriesCTA, null)), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null));
};

export { AccessoriesEcommContent };
//# sourceMappingURL=AccessoriesEcommContent.js.map
